import { Component, OnInit, HostListener, ViewChild, TemplateRef, AfterViewInit, NgZone } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { InteractorService } from './core/services/interactor.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { interval } from 'rxjs';
import { SessionService } from './shared/services/session.service';
import { userSessionConstants } from 'src/app/config/config';
import { localStorageVariables, oktaConfigurations, clients } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { EnvService } from 'src/app/core/services/env.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from 'src/app/shared/services/auth.service';
import { QuestionnaireInteractionService } from './core/services/questionnaire-interaction.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfimationPopupComponent } from './common/confimation-popup/confimation-popup.component';
import { localStorageConstants } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LoginService } from './core/services/login.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './common/header/header.component';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { RolePermissionService } from 'src/app/core/services/role-permission.service';
import { QuestionnaireService } from './core/services/questionnaire.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { CallBackTransformService } from './core/services/call-back-transform.service';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { CustomOverlayComponentComponent } from './common/custom-overlay-component/custom-overlay-component.component';
import { LanguageService } from './core/services/language.service';
import { CustomizationService } from './core/services/customization.service';
import { CommonService } from './shared/services/common.service';
import { AssessmentService } from './core/services/assessment.service';
import { FeatureFlagService } from './core/services/feature-flag.service';
import { IntercomService } from './core/services/intercom.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {

  @ViewChild(ConfimationPopupComponent) confirmDiscard: ConfimationPopupComponent;
  @ViewChild(HeaderComponent) headerComponent: HeaderComponent;
  modalRef: BsModalRef;
  language: any;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  permissions: any;
  menuPermissions: any = {
    sideBarMenu: false,
  };
  redirectURL: any;
  refresh: boolean = false;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  toastErrorBgColor: any;
  toastSuccessBgColor: any;
  toastErrorFontColor: any;
  toastSuccessFontColor: any;
  headerColor = this.brandingDetails?.branding?.BackgroundColors?.Headers
  boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
  regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
  webKit = this.brandingDetails?.branding?.BackgroundColors?.WebKit;
  semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
  blackColor = this.brandingDetails?.branding?.BackgroundColors?.NotesExpandButtonHover;
  whiteColor = this.brandingDetails?.branding?.BackgroundColors?.PaginationDisabledBackground;
  btnLogo = this.brandingDetails?.branding?.BackgroundColors?.BtnLogoContainer;
  modalColor = this.brandingDetails?.branding?.BackgroundColors?.ModalBackground;
  notification1: any;
  notification2: any;
  dashboardBorder: any;
  cancelButtonHover: any;
  cancelButton: any;
  button1: any;
  button2: any;
  buttonHover: any;
  buttonFont: any;
  activateBtn: any;
  buttonFontColor: any;
  EditBtn: any;
  EditBtnHover: any;
  redBtn: any;
  blueBtn: any;
  greenBtn: any;
  confirmDeleteBtn: any;
  confirmDeleteBtnHover: any;
  confirmCancelBtn: any;
  alternateRowsLight: any;
  alternateRowsDark: any;
  headerBackground: any;
  selectPersonStatus: any;
  tableHeadColor: any;
  disabledHeaderBackground: any;
  disableCategoryColor:any;
  editButtonBackground: any;
  editButtonHoverBackground: any;
  gridBorderColor: any;
  matTealDark: any;
  matError: any;
  matWhite: any;
  matOrange: any;
  matGreenYellow: any;
  matGreyGreen: any;
  matLightGreen: any;
  matBlack: any;
  matRussianBlack: any;
  matInputGrey: any;
  matCheckBoxBg: any;
  checkedCheckBoxBg: any;
  matTealLight: any;
  calenderNotSelectedBg: any;
  datePickerContent: any;
  checkBoxDisabledBg: any;
  headerFontColor: any;
  breadcrumbBg: any;
  tableFontColor: any;
  greyLightBg: any;
  tabBody: any;
  cardFontColor: any;
  linkButtons: any;
  dropdownBorderColor: any;
  btnLightBlue: any;
  isBrandingCompleted = false;
  questionnaireSubHeader: any;
  activeTabColor: any;
  disabledQuestionnaireHeader: any;
  subTabBgColor: any;
  cardCancelButton: any;
  activeAdminTabFontColor: any;
  showOverlay: boolean = false;
  inputsValue: any;
  private didDisablePageInputs = false;
  public overlayRef: OverlayRef;
  confirmCastTriggerFrom: any;
  confirmCastValue :any= {}
  isActiveModal: boolean = false;
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    public cookieService: CookieService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public interactorService: InteractorService,
    private spinner: NgxSpinnerService,
    private sessionService: SessionService,
    private localStorageService: LocalStorageService,
    private oauthService: OAuthService,
    private envService: EnvService,
    private authService: AuthService,
    private qiService: QuestionnaireInteractionService,
    private modalService: BsModalService,
    private loginService: LoginService,
    private location: Location,
    private translatorService: TranslateService,
    private rolePermissionService: RolePermissionService,
    private qService: QuestionnaireService,
    private lookupService: LookupService,
    private callBackTransformService: CallBackTransformService,
    private overlay: Overlay,
    private languageService : LanguageService,
    private customizationService : CustomizationService,
    private commonService: CommonService,
    private assessmentService: AssessmentService,
    private featureFlagService: FeatureFlagService,
    private intercomService: IntercomService,
    private ngZone: NgZone
  ) {

    this.translatorService.setDefaultLang('en');
    this.translatorService.use(localStorage.getItem('lang') || 'en');
    this.checkInActivity();
    this.qService.refreshData.subscribe(val => {
      if (val) {
        this.refresh = val;
      }
    });
  }

  title = 'opeeka';
  public authentication = false;
  public isEmailAssessment = false;
  public token;
  public refreshToken;
  public name;
  public phone;
  public userId;
  public userType;
  public showLoader = false;
  public isChanged = false;
  currentTime: any = new Date();
  prevTime: any = new Date();
  loginTime: any = new Date();
  public isConfirm = false;
  public message = 'Do you want to discard your changes before proceeding?';
  public nextRoute = null;
  public errorMessage: string;
  public error = false;

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.recordUserActivity();
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardDownEvent(event: KeyboardEvent): void {
    const restrictedKeys = ['Tab', 'Delete', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' ', 'Backspace'];
    if (
      this.showOverlay ||
      this.isActiveModal &&
      window?.location?.pathname.includes('/people/details') &&
      restrictedKeys.includes(event.key)
    ) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  // mousemove/touchmove are in __zone_symbol__UNPATCHED_EVENTS (src/zone-flags.ts, PCIS-11524),
  // so this handler runs outside Angular's zone and never schedules change detection - which is
  // correct, since it only records idle-tracking state that no template binds to.
  @HostListener('document:mousemove', ['$event'])
  handleMouseEvent(event: MouseEvent) {
    this.recordUserActivity();
  }

  // sessionTime is only ever read at whole-second granularity (the loginTime diffSeconds check
  // in ngOnInit), but mousemove invokes this dozens of times per second, and every
  // localStorage write also fires a 'storage' event in every other open same-origin tab
  // (PCIS-11524 - e.g. a report launched in a new tab), so cap the writes at one per second.
  private lastActivityWriteMs = 0;
  private recordUserActivity() {
    const now = Date.now();
    if (now - this.lastActivityWriteMs >= 1000) {
      this.lastActivityWriteMs = now;
      localStorage.setItem('sessionTime', now.toString());
    }
    if (this.sessionService.getTick() < userSessionConstants.idleTimeLimit) {
      this.sessionService.resetTick();
    }
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }



  ngOnInit() {
    sessionStorage.setItem('firstLogin', sessionStorage.getItem('isFirstLogin'));
    (window as any).currentEnvFlag = this.envService.env;
    this.setBackgroundColors();
    this.setFontColors();
    this.setMatColors();
    this.headerColor = this.brandingDetails?.branding.BackgroundColors.Headers;
    this.semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
    this.webKit = this.brandingDetails?.branding?.BackgroundColors?.WebKit;
    this.regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
    this.boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
    this.blackColor = this.brandingDetails?.branding?.BackgroundColors?.NotesExpandButtonHover;
    this.whiteColor = this.brandingDetails?.branding?.BackgroundColors?.PaginationDisabledBackground;
    this.btnLogo = this.brandingDetails?.branding?.BackgroundColors?.BtnLogoContainer;
    this.modalColor = this.brandingDetails?.branding?.BackgroundColors?.ModalBackground;
    if (this.headerColor) {
      this.headerColor = this.brandingDetails?.branding.BackgroundColors.Headers;
      this.semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
      this.regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
      this.boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
      this.webKit = this.brandingDetails?.branding?.BackgroundColors?.WebKit;
      this.btnLogo = this.brandingDetails?.branding?.BackgroundColors?.BtnLogoContainer;
      this.blackColor = this.brandingDetails?.branding?.BackgroundColors?.NotesExpandButtonHover;
      this.modalColor = this.brandingDetails?.branding?.BackgroundColors?.ModalBackground;
      document.documentElement.style.setProperty('--headerColor', this.headerColor);
      document.documentElement.style.setProperty('--semiBoldFont', this.semiBoldFont);
      document.documentElement.style.setProperty('--regularFont', this.regularFont);
      document.documentElement.style.setProperty('--boldFont', this.boldFont);
      document.documentElement.style.setProperty('--blackColor', this.blackColor);
      document.documentElement.style.setProperty('--whiteColor', this.whiteColor);
      document.documentElement.style.setProperty('--webKit', this.webKit);
      document.documentElement.style.setProperty('--btnLogo', this.btnLogo);
      document.documentElement.style.setProperty('--modalColor', this.modalColor);
      this.isBrandingCompleted = true;
    }
    const currentUrlPath = this.location.path().split('?');
    const currentPath = this.location.path();
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let tokenHint = params.get("token_hint");
    let client = params.get("client");
    let token_Hint = this.activatedRoute.snapshot.queryParamMap.get('token_hint');
    console.log('token_Hint by activatedRoute app component 174: ', token_Hint);
    console.log('tokenHint in app component 175: ', tokenHint);
    if (tokenHint !== '' && tokenHint !== undefined && tokenHint !== null) {
      sessionStorage.setItem('token_hint', tokenHint)
      params.delete('token_hint');
      let redirectPath = url.origin + url.pathname + '/?' + params.toString();
      if (!sessionStorage.getItem('redirectUrl')) {
        sessionStorage.setItem('redirectUrl', redirectPath);
      }
      this.commonService?.safeRedirect(url.origin);
    }
    // Handle client parameter from URL query string (for deep linking)
    if (client) {
      if (!sessionStorage.getItem('redirectUrl')) {
        sessionStorage.setItem('redirectUrl', window.location.href);
        console.log('App component - set redirectUrl (client param):', window.location.href);
      }
      sessionStorage.setItem('client', client);
    }
    if (currentPath.includes(clients.safy) || currentPath.includes(clients.cdss)) {
      if (!sessionStorage.getItem('redirectUrl')) {
        sessionStorage.setItem('redirectUrl', window.location.href);
        console.log('App component - set redirectUrl (path check):', window.location.href);
      }
      sessionStorage.setItem('path', currentPath)
      sessionStorage.setItem('client', currentPath.includes(clients.safy) ? clients.safy : clients.cdss);
    }
    this.isEmailAssessment = false;
    if (currentUrlPath.length > 0) {
      if (currentUrlPath[0] === '/E-ass') {
        this.isEmailAssessment = true;
        sessionStorage.setItem('isEmailAssessment', 'true');
      } else {
        sessionStorage.setItem('isEmailAssessment', 'false');
      }
    }
    window.addEventListener('storage', (event) => {
      // Scoped to the dedicated userSwitchSignal key (PCIS-11524), not "any localStorage write":
      // reacting to every write meant a tab's own reload (which re-writes several keys on init,
      // e.g. ApplicationTimeout/LastLogin) could re-trigger this same listener in another open tab,
      // whose reload then re-triggered this tab back - a self-sustaining cross-tab reload cascade
      // whenever two tabs (e.g. a report opened via "Launch in new tab") were open within the
      // switchUser cookie's 20s window, matching the reported memory growth/unresponsiveness.
      if (event.storageArea == localStorage && event.key === localStorageConstants.userSwitchSignal) {
        if (this.cookieService.get('switchUser') == 'true') {
          location.reload();
          // location.href = 'dashboard';
          //put 5 second delay for realod all the opened tab.
          setTimeout(() => {
            this.cookieService.set('switchUser', 'false', undefined, '/', undefined, true, 'Strict')
          }, 20000);
        }
      }
      if (event.key === 'lang') {
        // 'storage' is in __zone_symbol__UNPATCHED_EVENTS (src/zone-flags.ts, PCIS-11524), so this
        // handler runs outside Angular's zone; re-enter it for the one branch that updates the UI.
        this.ngZone.run(() => {
          this.language = event.newValue || 'en';
          this.translatorService.use(this.language);
        });
      }
    });
    if (sessionStorage.getItem('isFirstLogin') === 'true') {
      this.assessmentService.getAssessmentConfigurations().subscribe((output: any) => {
        if (output.StatusCode === 200) {
          if (output.Data) {
            localStorage.setItem('assessmentFileMaxSize', output.Data?.assessmentFileMaxSize);
          }
        }
      })
      // tslint:disable-next-line: deprecation
      this.loginService.updateLastLogin().subscribe((response: any) => {
        // alert(response.Data?.agencyLanguageId)

        localStorage.setItem('agencyLanguageId', response.Data?.agencyLanguageId);
        localStorage.setItem('isAdvanceSearchBE', 'false');
        localStorage.setItem('LastLogin', response.Data?.lastLogin);
        localStorage.setItem('assessmentAutoSaveTime', response.Data?.assesmentAutoSaveTime);
        localStorage.setItem('ApplicationTimeout', response.Data?.applicationTimeout);
        localStorage.setItem('AssesmentPageCount', response.Data?.assesmentPageCount);
        localStorage.setItem('ShowTips', response.Data?.isShowTips);
        sessionStorage.removeItem('isFirstLogin');
        // let languages = JSON.parse(localStorage.getItem('languageList'))?.result?.agencyLanguage;
        this.checkInActivity();
        this.lookupService.getLanguages().subscribe(
          (res) => {
            if (res.StatusCode !== 200) {
              this.error = true;
              this.message = res.Message;
            } else {
              let languages = res.Data.agencyLanguage;
              let currentLanguage = languages?.find((x) => x.agencyLanguageID == response.Data?.agencyLanguageId);
              this.language = response.Data?.language;
              localStorage.setItem('lang', currentLanguage?.attribute);
              this.languageService.languageValueSet.next(languages);
            }
          },
          (err) => {
            this.error = true;
            this.message = err.Message;
          }
        );

      }, err => {
        sessionStorage.removeItem('isFirstLogin');
      });

      this.lookupService.getDefaultBrandingDetails(0).subscribe(
        (res) => {
          if (res.StatusCode !== 200) {
            this.error = true;
            this.message = res.Message;
          } else {
            let defaultBranding = res.Data;
          }
        },
        (err) => {
          this.error = true;
          this.message = err.Message;
        }
      );
    }
    if(localStorage.getItem('token') && !this.isEmailAssessment) {
      this.getBrandingDetails();
    }
    this.errorMessage = localStorageConstants.errorMessage;
    if (typeof document !== 'undefined') {
      if (typeof document.referrer !== 'undefined' && document.referrer != null) {
        if (this.getDomain(document.referrer) === this.getDomain(this.envService.adb2cTenantUrl)) {
          localStorage.setItem('sessionTime', (new Date().getTime()).toString());
        }
      }
    }
    // tslint:disable-next-line: radix
    const diffSeconds = (this.loginTime.getTime() - parseInt(localStorage.getItem('sessionTime'))) / 1000;
    const applocationTimeOut = parseInt(localStorage.getItem('ApplicationTimeout'))
    if (diffSeconds > applocationTimeOut && window.location.pathname != '/E-ass') {
      this.cookieService.deleteAll('');
      this.cookieService.deleteAll('/');
      this.cookieService.deleteAll('/', window.location.hostname);
      this.cookieService.deleteAll('/', 'https://' + window.location.hostname);
      this.localStorageService.deleteAllLocalStorage();
      const claims = this.oauthService.getIdentityClaims();
      this.oauthService.logOut(false);
      this.oauthService.revokeTokenAndLogout();
      if (currentUrlPath[1].includes('client')) {
        this.activatedRoute.queryParamMap.subscribe(queryParams => {
          const client = queryParams.get("client");
          if (client) {
            this.loginService.getSSOConfigurations(client).subscribe((response: any) => {
              this.redirectURL = response?.Data?.redirectURL;
              this.commonService?.safeRedirect(this.redirectURL);
            }, err => {
            });
          }
        });
      } else {
        window.location.href = this.envService.logoutUrl;
      }
    }
    // tslint:disable-next-line: deprecation
    this.qiService.valueChangesCast.subscribe((val) => {
      this.isChanged = val;
    });
    // tslint:disable-next-line: deprecation
    this.qiService.isShowConfirmCast.subscribe((val: any) => {
      if (val) {
        this.confirmCastTriggerFrom=val?.triggerFrom;
        this.nextRoute = val?.route;
        if (this.isChanged) {
          this.confirmDiscard.openModal();
        }
      }
    });
    // tslint:disable-next-line: deprecation
    this.interactorService.errorCast.subscribe(val => {
      if (val) {
        this.error = val;
      }
    });
    // tslint:disable-next-line: triple-equals
    this.authentication = (typeof this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) != 'undefined' &&
      // tslint:disable-next-line: triple-equals
      this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) != '' &&
      this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) != null) ? true : false;

    this.initMenuSection();
    // tslint:disable-next-line: deprecation
    this.interactorService.loaderCast.subscribe(value => {
      if (value) {
        this.spinner.show();
      } else {
        this.spinner.hide();
      }
    });
    this.getPermissions();
    this.interactorService?.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.setBackgroundColors();
      }
    });
    this.lookupService.showOverlay.subscribe((value: boolean) => {
      this.showOverlay = value;
      if (value) {
        const activeElement = document.activeElement;
        if (activeElement) {
          var id = activeElement.id;
          if (activeElement.nodeName == "INPUT" || activeElement.tagName == "INPUT") {
            document.getElementById(id)?.blur();
          }
        }
        if (this.overlayRef) {
          // dispose(), not detach(): this branch immediately discards the JS reference by
          // reassigning overlayRef below, so detach() alone left the old overlay's backdrop +
          // pane wrapper (an empty but permanent element) in the DOM on every single one of
          // these cycles - which fire on every HTTP request/response via showOverlay
          // (PCIS-11524).
          this.overlayRef.dispose();
        }
        this.overlayRef = this.overlay.create({
          hasBackdrop: true,
          positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
        });

        const overlayPortal = new ComponentPortal(CustomOverlayComponentComponent);
        this.overlayRef.attach(overlayPortal);
        this.inputsValue = Array.from(document.getElementsByTagName('input'));
        if (this.inputsValue && this.inputsValue.length > 0 && window?.location?.pathname.includes('/people/details')) {
          this.didDisablePageInputs = true;
          for (var i = 0; i < this.inputsValue.length; i++) {
            if (this.inputsValue[i].disabled) {
              (this.inputsValue[i] as any).isalready = true;
            }
            this.inputsValue[i].disabled = true;
          }
        }
      } else {
        if (this.overlayRef) {
          this.overlayRef.detach();
          const currentInputs = Array.from(document.getElementsByTagName('input'));
          // Gate re-enable on whether we actually disabled inputs, not on the current pathname:
          // navigating away from /people/details (e.g. confirming discard from the left-nav
          // guard) between disable and re-enable would otherwise strand the header Search
          // field disabled forever (PCIS-11519).
          if (this.inputsValue && this.inputsValue.length > 0 && this.didDisablePageInputs) {
            for (let i = 0; i < this.inputsValue.length; i++) {
              const savedInput = this.inputsValue[i];
              if (!currentInputs.includes(savedInput)) {
                savedInput.disabled = false;
              }
            }
            for (let i = 0; i < currentInputs.length; i++) {
              if (!(currentInputs[i] as any).isalready) {
                currentInputs[i].disabled = false;
              }
            }
            this.didDisablePageInputs = false;
          }
        }
      }
    });
    this.lookupService.isActiveModal.subscribe((value: boolean) => {
      this.isActiveModal = value;
    })

    this.initFeatureFlags().then(() => {
      //console.log('Feature Flags Initialized');
      this.initIntercom();
    });
  }

  initFeatureFlags() {
    const userId = this.localStorageService.getDataFromLocalStorage(localStorageVariables.UserId);
    const email = this.localStorageService.getDataFromLocalStorage(localStorageVariables.email);
    const userRole = this.localStorageService.getDataFromLocalStorage(localStorageVariables.role);
    const agency = this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyName);
    const agencyId = this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyId);
    const subdomain = window.location.hostname;

    // Multi-context structure for LaunchDarkly
    const context = {
      kind: "multi",
      user: {
        key: userId,
        kind: "user",
        email: email,
        role: userRole
      },
      organization: {
        key: agencyId,
        kind: "organization",
        name: agency,
        subdomain: subdomain
      }
    };

    return this.featureFlagService.initialize(context);
  }

  initIntercom() {
    const userId = this.localStorageService.getDataFromLocalStorage(localStorageVariables.UserId);
    const email = this.localStorageService.getDataFromLocalStorage(localStorageVariables.email);
    const userRole = this.localStorageService.getDataFromLocalStorage(localStorageVariables.role);
    const agency = this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyName);
    const agencyId = this.localStorageService.getDataFromLocalStorage(localStorageVariables.agencyId);

    // Intercom user profile with company and role attributes
    const userData = {
      user_id: userId,
      email,
      UserRole: userRole,
      AgencyName: agency,
      AgencyID: agencyId,
      Environment: this.envService.env
    }

    this.intercomService.boot(userData);
  }

  getBrandingDetails(){
    this.lookupService.getBrandingDetails().subscribe(
      (res) => {
        if (res.StatusCode !== 200) {
          this.error = true;
          this.message = res.Message;
        } else {
          let branding = res.Data;
          this.interactorService.changeBrandingDetails(branding);
          this.headerColor = branding?.branding.BackgroundColors.Headers;
          document.documentElement.style.setProperty('--headerColor', this.headerColor);
          this.setBackgroundColors();
          this.setFontColors();
          this.setMatColors();
          this.isBrandingCompleted = true;
          this.customizationService.brandingValueSet.next(branding);
        }
      },
      (err) => {
        this.error = true;
        this.message = err.Message;
      }
    );
  }


  ngAfterViewInit() {}

  getDomain(url) {
    const hostname = window && window.location.hostname && window.location.hostname;
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
      return match[2];
    } else {
      return null;
    }
  }

  populateUserCookieValues() {
    this.token = this.localStorageService.getDataFromLocalStorage(localStorageVariables.token);
    this.refreshToken = this.localStorageService.getDataFromLocalStorage(localStorageVariables.refreshToken);
    this.name = this.localStorageService.getDataFromLocalStorage(localStorageVariables.name);
    this.phone = this.localStorageService.getDataFromLocalStorage(localStorageVariables.phone);
    this.userId = this.localStorageService.getDataFromLocalStorage(localStorageVariables.UserId);
    this.userType = this.localStorageService.getDataFromLocalStorage(localStorageVariables.userType);

  }
  initMenuSection() {
    // tslint:disable-next-line: deprecation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // tslint:disable-next-line: triple-equals
        if (typeof this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) != 'undefined'
          // tslint:disable-next-line: triple-equals
          && this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) != '' &&
          this.localStorageService.getDataFromLocalStorage(localStorageVariables.token) != null) {
          // tslint:disable-next-line: triple-equals
          if (this.authentication == false) {
            this.authentication = true;
            this.sessionService.resetTick();
          }
        } else {
          this.authentication = false;
        }

      }
    });

  }

  getPermissions() {
    const tenantAbbreviation = this.localStorageService.getDataFromLocalStorage(localStorageVariables.tenantAbbreviation);
    if (tenantAbbreviation && !this.isEmailAssessment) {
      // tslint:disable-next-line: deprecation
      this.rolePermissionService.getPermissions(tenantAbbreviation).subscribe(res => {
        if (res.StatusCode === 200) {
          this.permissions = res.Data;
          this.menuPermissions.sideBarMenu = this.rolePermissionService.isAuthorized('SidebarMenu', 'View');
        }
      }, () => {
        this.error = true;
        this.message = localStorageConstants.errorMessage;
      });
    }
  }

  findTenantAbbreviation() {
    const hostname = window && window.location.hostname && window.location.hostname;
    if (/^.*localhost.*/.test(hostname)) {
      return environment.tenantAbbreviation;
    } else {
      return hostname.split('.')[0]; // return subdomain as tenantAbbreviation
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered',
    });
  }

  getModalEvent(event) {
    this.confirmCastValue={}
    if (event) {
      this.qiService.setValueChange(false);
      this.qiService.setConfirmation(null);
      // If on people-details page, trigger reset of modification flags
      if (window?.location?.pathname.includes('/people/details')) {
        this.qiService.setValueLeaveWithoutSave(true);
      }
      if (this.nextRoute) {
        this.router.navigateByUrl(this.nextRoute);
      }
    } else {
      this.qiService.setConfirmation(null);
    }
    if(this.confirmCastTriggerFrom){
      this.confirmCastValue={
        triggerFrom:this.confirmCastTriggerFrom,
        value:event
      }
      if(event){
        this.commonService.triggerClearAssessment();
      }
    }
  }

  popupHideCallback(event) {
    if (event === false) {
      this.error = false;
      if (this.refresh) { window.location.reload(); }
    }
  }

  setBackgroundColors() {
    this.toastErrorBgColor = this.brandingDetails?.branding?.AlertColors?.ErrorAlertColor;
    this.toastSuccessBgColor = this.brandingDetails?.branding?.AlertColors?.SuccessAlertColor;
    this.notification1 = this.brandingDetails?.branding.BackgroundColors?.Notification1;
    this.notification2 = this.brandingDetails?.branding.BackgroundColors?.Notification2;
    this.cancelButton = this.brandingDetails?.branding.BackgroundColors?.CancelBtnAddPerson;
    this.cancelButtonHover = this.brandingDetails?.branding.BackgroundColors?.CancelBtnAddPersonHover;
    this.dashboardBorder = this.brandingDetails?.branding.BackgroundColors?.DashboardNotificationBorder;
    this.button2 = this.brandingDetails?.branding.BackgroundColors?.Button2;
    this.buttonHover = this.brandingDetails?.branding.BackgroundColors?.ButtonHover;
    this.buttonFontColor = this.brandingDetails?.branding.BackgroundColors?.BtnFont;
    this.activateBtn = this.brandingDetails?.branding.BackgroundColors?.ActivateBtn;
    this.EditBtn = this.brandingDetails?.branding.BackgroundColors?.EditBtn;
    this.EditBtnHover = this.brandingDetails?.branding.BackgroundColors?.EditBtnHover;
    this.redBtn = this.brandingDetails?.branding.BackgroundColors?.BtnRed;
    this.blueBtn = this.brandingDetails?.branding.BackgroundColors?.BtnBlue;
    this.greenBtn = this.brandingDetails?.branding.BackgroundColors?.BtnGreen;
    this.confirmDeleteBtnHover = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtnHover;
    this.confirmDeleteBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtn;
    this.confirmCancelBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmCancelBtn;
    this.alternateRowsLight = this.brandingDetails?.branding?.BackgroundColors?.AlternateRowsLight;
    this.alternateRowsDark = this.brandingDetails?.branding?.BackgroundColors?.AlternateRowsDark;
    this.headerBackground = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.selectPersonStatus = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.disabledHeaderBackground = this.brandingDetails?.branding?.BackgroundColors?.DisabledHeaderBackground;
    this.disableCategoryColor = this.brandingDetails?.branding?.BackgroundColors?.DisableCategoryColor;
    this.editButtonBackground = this.brandingDetails?.branding?.BackgroundColors?.EditBtn;
    this.editButtonHoverBackground = this.brandingDetails?.branding?.BackgroundColors?.EditBtnHover;
    this.gridBorderColor = this.brandingDetails?.branding?.BackgroundColors?.GridBorder;
    this.greyLightBg = this.brandingDetails?.branding?.BackgroundColors?.SideBarBackground;
    this.tabBody = this.brandingDetails?.branding?.BackgroundColors?.TabBody;
    this.cardFontColor = this.brandingDetails?.branding?.BackgroundColors?.CardFontColor;
    this.dropdownBorderColor = this.brandingDetails?.branding?.BackgroundColors?.DropdownBorder;
    this.btnLightBlue = this.brandingDetails?.branding?.BackgroundColors?.ResendColor;
    this.questionnaireSubHeader = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireSubHeader;
    this.disabledQuestionnaireHeader = this.brandingDetails?.branding?.BackgroundColors?.DisabledQuestionnaireHeader;
    this.subTabBgColor = this.brandingDetails?.branding.BackgroundColors?.CardBg;
    this.cardCancelButton = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardCancelButton;
    this.activeAdminTabFontColor = this.brandingDetails?.branding?.BackgroundColors?.ActiveAdminTabFontColor;

    if (this.toastErrorBgColor) {
      document.documentElement.style.setProperty('--toastErrorBgColor', this.toastErrorBgColor);
    }
    if (this.toastSuccessBgColor) {
      document.documentElement.style.setProperty('--toastSuccessBgColor', this.toastSuccessBgColor);
    }
    if (this.notification1) {
      document.documentElement.style.setProperty('--notification1', this.notification1);
    }
    if (this.notification2) {
      document.documentElement.style.setProperty('--notification2', this.notification2);
    }
    if (this.dashboardBorder) {
      document.documentElement.style.setProperty('--dashboardBorder', this.dashboardBorder);
    }
    if (this.cancelButton) {
      document.documentElement.style.setProperty('--cancelButton', this.cancelButton);
    }
    if (this.cancelButtonHover) {
      document.documentElement.style.setProperty('--cancelButtonHover', this.cancelButtonHover);
    }
    if (this.button2) {
      document.documentElement.style.setProperty('--button2', this.button2);
    }
    if (this.buttonHover) {
      document.documentElement.style.setProperty('--buttonHover', this.buttonHover);
    }
    if (this.activateBtn) {
      document.documentElement.style.setProperty('--activateBtn', this.activateBtn);
    }
    if (this.buttonFontColor) {
      document.documentElement.style.setProperty('--buttonFontColor', this.buttonFontColor);
    }
    if (this.EditBtn) {
      document.documentElement.style.setProperty('--EditBtn', this.EditBtn);
    }
    if (this.EditBtnHover) {
      document.documentElement.style.setProperty('--EditBtnHover', this.EditBtnHover);
    }
    if (this.alternateRowsLight) {
      document.documentElement.style.setProperty('--alternateRowsLight', this.alternateRowsLight);
    }
    if (this.alternateRowsDark) {
      document.documentElement.style.setProperty('--alternateRowsDark', this.alternateRowsDark);
    }
    if (this.headerBackground) {
      document.documentElement.style.setProperty('--headerBackground', this.headerBackground);
    }
    if (this.selectPersonStatus) {
      document.documentElement.style.setProperty('--selectPersonStatus', this.headerBackground);
    }
    if (this.disabledHeaderBackground) {
      document.documentElement.style.setProperty('--disabledHeaderBackground', this.disabledHeaderBackground);
    }
    if (this.disableCategoryColor) {
      document.documentElement.style.setProperty('--disableCategoryColor', this.disableCategoryColor);
    }
    if (this.editButtonBackground) {
      document.documentElement.style.setProperty('--editButtonBackground', this.editButtonBackground);
    }
    if (this.editButtonHoverBackground) {
      document.documentElement.style.setProperty('--editButtonHoverBackground', this.editButtonHoverBackground);
    }
    if (this.confirmDeleteBtnHover) {
      document.documentElement.style.setProperty('--confirmDeleteBtnHover', this.confirmDeleteBtnHover);
    }
    if (this.confirmDeleteBtn) {
      document.documentElement.style.setProperty('--confirmDeleteBtn', this.confirmDeleteBtn);
    }
    if (this.confirmCancelBtn) {
      document.documentElement.style.setProperty('--confirmCancelBtn', this.confirmCancelBtn);
    }
    if (this.gridBorderColor) {
      document.documentElement.style.setProperty('--gridBorderColor', this.gridBorderColor);
    }
    if (this.redBtn) {
      document.documentElement.style.setProperty('--redBtn', this.redBtn);
    }
    if (this.blueBtn) {
      document.documentElement.style.setProperty('--blueBtn', this.blueBtn);
    }
    if (this.greenBtn) {
      document.documentElement.style.setProperty('--greenBtn', this.greenBtn);
    }
    if (this.greyLightBg) {
      document.documentElement.style.setProperty('--greyLightBg', this.greyLightBg);
    }
    if (this.tabBody) {
      document.documentElement.style.setProperty('--tabBody', this.tabBody);
    }
    if (this.cardFontColor) {
      document.documentElement.style.setProperty('--cardFontColor', this.cardFontColor);
    }
    if (this.dropdownBorderColor) {
      document.documentElement.style.setProperty('--dropdownBorderColor', this.dropdownBorderColor);
    }
    if (this.btnLightBlue) {
      document.documentElement.style.setProperty('--btnLightBlue', this.btnLightBlue);
    }
    if (this.questionnaireSubHeader) {
      document.documentElement.style.setProperty('--questionnaireSubHeader', this.questionnaireSubHeader);
    }
    if (this.disabledQuestionnaireHeader) {
      document?.documentElement?.style?.setProperty('--disabledQuestionnaireHeader', this.disabledQuestionnaireHeader);
    }
    if (this.subTabBgColor) {
      document?.documentElement?.style?.setProperty('--subTabBgColor', this.subTabBgColor);
    }
    if (this.cardCancelButton) {
      document?.documentElement?.style?.setProperty('--cardCancelButton', this.cardCancelButton);
    }
    if (this.activeAdminTabFontColor) {
      document.documentElement.style.setProperty('--activeAdminTabFontColor', this.activeAdminTabFontColor);
    }
  }

  setFontColors() {
    this.toastErrorFontColor = this.brandingDetails?.branding?.AlertColors?.ErrorAlertFontColor;
    this.toastSuccessFontColor = this.brandingDetails?.branding?.AlertColors?.SuccessAlertFontColor;
    this.buttonFont = this.brandingDetails?.branding.BackgroundColors?.BtnFont;
    this.tableHeadColor = this.brandingDetails?.branding?.BackgroundColors?.TableHeadColor;
    this.headerFontColor = this.brandingDetails?.branding?.BackgroundColors?.HeaderFontColor;
    this.tableFontColor = this.brandingDetails?.branding?.BackgroundColors?.TableFontColor;
    this.breadcrumbBg = this.brandingDetails?.branding?.BackgroundColors?.SidebarHoverBackground;
    this.linkButtons = this.brandingDetails?.branding.BackgroundColors?.LinkButtons;
    this.activeTabColor = this.brandingDetails?.branding?.BackgroundColors?.BlackHeaderFont;
    if (this.toastErrorFontColor) {
      document.documentElement.style.setProperty('--toastErrorFontColor', this.toastErrorFontColor);
    }
    if (this.toastSuccessFontColor) {
      document.documentElement.style.setProperty('--toastSuccessFontColor', this.toastSuccessFontColor);
    }
    if (this.buttonFont) {
      document.documentElement.style.setProperty('--buttonFont', this.buttonFont);
    }
    if (this.tableHeadColor) {
      document.documentElement.style.setProperty('--tableHeadColor', this.tableHeadColor);
    }
    if (this.headerFontColor) {
      document.documentElement.style.setProperty('--headerFontColor', this.headerFontColor);
    }
    if (this.tableFontColor) {
      document.documentElement.style.setProperty('--tableFontColor', this.tableFontColor);
    }
    if (this.breadcrumbBg) {
      document.documentElement.style.setProperty('--breadcrumbBg', this.breadcrumbBg);
    }
    if (this.linkButtons) {
      document.documentElement.style.setProperty('--linkButtons', this.linkButtons);
    }
    if (this.activeTabColor) {
      document.documentElement.style.setProperty('--activeTabColor', this.activeTabColor);
    }
  }

  setMatColors() {
    this.matTealDark = this.brandingDetails?.branding?.MatColors?.MatTealDark;
    this.matBlack = this.brandingDetails?.branding?.MatColors?.MatBlack;
    this.matWhite = this.brandingDetails?.branding?.MatColors?.MatWhite;
    this.matOrange = this.brandingDetails?.branding?.MatColors?.MatOrange;
    this.matGreenYellow = this.brandingDetails?.branding?.MatColors?.MatGreenYellow;
    this.matGreyGreen = this.brandingDetails?.branding?.MatColors?.MatGreyGreen;
    this.matLightGreen = this.brandingDetails?.branding?.MatColors?.MatLightGreen;
    this.matRussianBlack = this.brandingDetails?.branding?.MatColors?.MatRussianBlack;
    this.matInputGrey = this.brandingDetails?.branding?.MatColors?.MatInputGrey;
    this.matCheckBoxBg = this.brandingDetails?.branding?.MatColors?.MatCheckBoxBg;
    this.checkedCheckBoxBg = this.brandingDetails?.branding?.MatColors?.CheckedCheckBoxBg;
    this.matTealLight = this.brandingDetails?.branding?.MatColors?.MatTealLight;
    this.calenderNotSelectedBg = this.brandingDetails?.branding?.MatColors?.CalenderNotSelectedBg;
    this.datePickerContent = this.brandingDetails?.branding?.MatColors?.DatePickerContent;
    this.checkBoxDisabledBg = this.brandingDetails?.branding?.MatColors?.CheckBoxDisabledBg;
    this.matError = this.brandingDetails?.branding.BackgroundColors?.ErrorFontColor;

    if (this.matTealDark) {
      document.documentElement.style.setProperty('--matTealDark', this.matTealDark);
    }
    if (this.matWhite) {
      document.documentElement.style.setProperty('--matWhite', this.matWhite);
    }
    if (this.matOrange) {
      document.documentElement.style.setProperty('--matOrange', this.matOrange);
    }
    if (this.matGreenYellow) {
      document.documentElement.style.setProperty('--matGreenYellow', this.matGreenYellow);
    }
    if (this.matGreyGreen) {
      document.documentElement.style.setProperty('--matGreyGreen', this.matGreyGreen);
    }
    if (this.matLightGreen) {
      document.documentElement.style.setProperty('--matLightGreen', this.matLightGreen);
    }
    if (this.matRussianBlack) {
      document.documentElement.style.setProperty('--matRussianBlack', this.matRussianBlack);
    }
    if (this.matInputGrey) {
      document.documentElement.style.setProperty('--matInputGrey', this.matInputGrey);
    }
    if (this.matCheckBoxBg) {
      document.documentElement.style.setProperty('--matCheckBoxBg', this.matCheckBoxBg);
    }
    if (this.checkedCheckBoxBg) {
      document.documentElement.style.setProperty('--checkedCheckBoxBg', this.checkedCheckBoxBg);
    }
    if (this.matTealLight) {
      document.documentElement.style.setProperty('--matTealLight', this.matTealLight);
    }
    if (this.calenderNotSelectedBg) {
      document.documentElement.style.setProperty('--calenderNotSelectedBg', this.calenderNotSelectedBg);
    }
    if (this.datePickerContent) {
      document.documentElement.style.setProperty('--datePickerContent', this.datePickerContent);
    }
    if (this.checkBoxDisabledBg) {
      document.documentElement.style.setProperty('--checkBoxDisabledBg', this.checkBoxDisabledBg);
    }
    if (this.matError) {
      document.documentElement.style.setProperty('--matError', this.matError);
    }
  }

  checkInActivity () {
    const applicationTimeout = parseInt(localStorage.getItem('ApplicationTimeout'));
    if (applicationTimeout) {
      this.idle.setIdle(applicationTimeout);
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      this.idle.setTimeout(120);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      // Each handler body is wrapped in ngZone.run(): ng-idle emits most lifecycle events from
      // inside its own zone.run(), but the interrupt-driven paths can emit from a mousemove/
      // touchmove/storage listener, which run outside Angular's zone now that those events are in
      // __zone_symbol__UNPATCHED_EVENTS (src/zone-flags.ts, PCIS-11524). Re-entering here makes
      // the session-timeout UI (warning popup, countdown) independent of which path emitted.
      this.idle.onIdleEnd.subscribe(() => {
        this.ngZone.run(() => {
          this.idleState = 'No longer idle.'
          this.reset();
        });
      });

      this.idle.onTimeout.subscribe(() => {
        this.ngZone.run(() => {
          this.idleState = 'Timed out!';
          this.timedOut = true;
          this.sessionService.closePopup(false)
          this.cookieService.deleteAll('');
          this.cookieService.deleteAll('/');
          this.cookieService.deleteAll('/', window.location.hostname);
          this.cookieService.deleteAll('/', 'https://' + window.location.hostname);
          this.localStorageService.deleteAllLocalStorage();
          const claims = this.oauthService.getIdentityClaims();
          this.oauthService.logOut(false);
          this.oauthService.revokeTokenAndLogout();
          window.location.href = this.envService.logoutUrl;
        });
      });

      this.idle.onIdleStart.subscribe(() => {
        this.ngZone.run(() => {
          this.qiService.saveAssessmentBeforeTimeOut(true);
          this.sessionService.showPopup(true);
        });
      });

      this.idle.onTimeoutWarning.subscribe((countdown) => {
        this.ngZone.run(() => {
          this.idleState = 'You will time out in ' + countdown + ' seconds!'
          this.sessionService.timer(countdown);
        });
      });

      // sets the ping interval to 15 seconds
      this.keepalive.interval(15);
      this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
      this.reset();
    }
  }
}
